module.exports = __webpack_public_path__ + "img/承重使用.4da6b199.png";